var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronUpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1240_21957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 10.828L7.75772 15.071C7.36725 15.4615 6.73418 15.4615 6.34372 15.071C5.95325 14.6805 5.95325 14.0475 6.34372 13.657L11.2936 8.70711C11.6841 8.31658 12.3173 8.31658 12.7078 8.70711L17.6577 13.657C18.0482 14.0475 18.0482 14.6805 17.6577 15.071C17.2673 15.4615 16.6342 15.4615 16.2437 15.071L12.0007 10.828Z",
    fill: "#2B2C82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1240_21957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUpBlue);
export default __webpack_public_path__ + "static/media/icon-chevron-up-blue.223cf77cd12193885ea6bed6a5c97af5.svg";
export { ForwardRef as ReactComponent };